import script from "./AddUserToProductPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUserToProductPopup.vue?vue&type=script&setup=true&lang=js"

import "./AddUserToProductPopup.vue?vue&type=style&index=0&id=49c18e55&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49c18e55"]])

export default __exports__